(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weluxe-eventail"] && !Shopify.designMode) return;
  try {
    
  (function () {
    if (window.wlEventailOnglets) return;
    window.wlEventailOnglets = true;
    document.addEventListener('click', function (ev) {
      var onglet = ev.target && ev.target.closest ? ev.target.closest('.wl-evs__onglet') : null;
      if (!onglet) return;
      var racine = onglet.closest('.wl-evs');
      if (!racine) return;
      var cible = onglet.getAttribute('data-cible');
      Array.prototype.forEach.call(racine.querySelectorAll('.wl-evs__onglet'), function (o) {
        o.setAttribute('aria-pressed', o === onglet ? 'true' : 'false');
      });
      Array.prototype.forEach.call(racine.querySelectorAll('.wl-evs__panneau'), function (p) {
        var ev2 = p.querySelector('wl-eventail');
        if (!ev2) return;
        if (p.getAttribute('data-panneau') === cible) {
          if (typeof ev2.activer === 'function') ev2.activer(); else ev2.hidden = false;
        } else {
          ev2.hidden = true;
        }
      });
      var lien = racine.querySelector('[data-wl-evs-lien]');
      if (lien && onglet.getAttribute('data-url')) lien.setAttribute('href', onglet.getAttribute('data-url'));
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weluxe-galerie"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (!root || root.__wlG) return;
      root.__wlG = true;
      var panneaux = Array.prototype.slice.call(root.querySelectorAll('.wl-g__panneau'));
      if (!panneaux.length) return;
      var duree = parseInt(root.getAttribute('data-duree'), 10) || 5000;
      var actif = 0;
      var minuterie = null;
      var survol = false;
      var visible = true;
      var pret = reduit || !root.classList.contains('est-intro');

      function activer(i) {
        actif = i;
        panneaux.forEach(function (p, k) {
          p.classList.toggle('est-actif', k === i);
        });
      }
      function avancer() {
        clearTimeout(minuterie);
        root.classList.remove('est-auto');
        if (reduit || survol || !visible || !pret || panneaux.length < 2) return;
        void root.offsetWidth;
        root.classList.add('est-auto');
        minuterie = setTimeout(function () {
          activer((actif + 1) % panneaux.length);
          avancer();
        }, duree);
      }

      panneaux.forEach(function (p, i) {
        p.addEventListener('pointerenter', function (e) {
          if (e.pointerType !== 'mouse') return;
          survol = true;
          pret = true;
          activer(i);
          avancer();
        });
        p.addEventListener('focus', function () {
          if (!p.matches(':focus-visible')) return;
          survol = true;
          activer(i);
          avancer();
        });
        p.addEventListener('blur', function () {
          survol = false;
          avancer();
        });
        p.addEventListener('click', function (e) {
          if (actif !== i) {
            e.preventDefault();
            activer(i);
            avancer();
          }
        });
      });
      root.addEventListener('pointerleave', function (e) {
        if (e.pointerType !== 'mouse') return;
        survol = false;
        avancer();
      });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entrees) {
            visible = entrees[0].isIntersecting;
            avancer();
          },
          { threshold: 0.2 }
        ).observe(root);
      }

      if (!pret) {
        setTimeout(function () {
          root.classList.remove('est-intro');
          pret = true;
          avancer();
        }, 2300);
      } else {
        root.classList.remove('est-intro');
        avancer();
      }

      root.__wlActiver = function (i) {
        survol = true;
        activer(i);
        avancer();
      };
      root.__wlRelacher = function () {
        survol = false;
        avancer();
      };
    }

    function tout() {
      document.querySelectorAll('[data-wl-galerie]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tout);
    } else {
      tout();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[data-wl-galerie]');
      if (r) init(r);
    });
    document.addEventListener('shopify:block:select', function (e) {
      var p = e.target && e.target.closest ? e.target.closest('.wl-g__panneau') : null;
      if (!p) return;
      var root = p.closest('[data-wl-galerie]');
      if (!root || !root.__wlActiver) return;
      root.__wlActiver(Array.prototype.indexOf.call(root.querySelectorAll('.wl-g__panneau'), p));
    });
    document.addEventListener('shopify:block:deselect', function (e) {
      var root = e.target && e.target.closest ? e.target.closest('[data-wl-galerie]') : null;
      if (root && root.__wlRelacher) root.__wlRelacher();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["weluxe-vitrine"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduit = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function init(root) {
      if (!root || root.__wlV) return;
      root.__wlV = true;

      // Les pièces déjà montrées dans la galerie d'ouverture laissent leur place aux suivantes.
      var dejaVues = {};
      document.querySelectorAll('[data-wl-galerie] .wl-g__panneau').forEach(function (a) {
        dejaVues[a.getAttribute('href')] = true;
      });
      var toutes = Array.prototype.slice.call(root.querySelectorAll('.wl-v__etiquette'));
      var gardees = toutes.filter(function (a) { return !dejaVues[a.getAttribute('href')]; });
      if (gardees.length < 3) gardees = toutes;
      gardees = gardees.slice(0, 5);
      var gardeIds = gardees.map(function (a) { return a.getAttribute('data-i'); });
      root.querySelectorAll('[data-i]').forEach(function (el) {
        if (gardeIds.indexOf(el.getAttribute('data-i')) < 0) el.parentNode.removeChild(el);
      });

      var lumieres = Array.prototype.slice.call(root.querySelectorAll('.wl-v__lumiere .wl-v__piece'));
      var pieces = lumieres.map(function (im) {
        return {
          im: im,
          et: root.querySelector('.wl-v__etiquette[data-i="' + im.getAttribute('data-i') + '"]'),
          fx: parseFloat(im.getAttribute('data-fx')) || 0.5,
          fy: parseFloat(im.getAttribute('data-fy')) || 0.5,
          cx: 0,
          cy: 0,
          visible: true
        };
      });
      if (!pieces.length) return;

      var spot = { x: 0, y: 0, tx: 0, ty: 0, r: 0, tr: 0 };
      var mode = 'auto';
      var rang = 0;
      var depuis = 0;
      var dernier = 0;
      var visible = false;
      var boucle = false;
      var pret = false;
      var allume = false;
      var W = 1;
      var H = 1;
      var ARRET = 2900;

      function rayon() { return Math.max(110, Math.min(W * 0.19, 240)); }

      function geo() {
        var s = root.getBoundingClientRect();
        W = s.width;
        H = s.height;
        var etroit = W < 640;
        var entete = root.querySelector('.wl-v__entete');
        var basEntete = entete ? entete.getBoundingClientRect().bottom - s.top : 60;
        pieces.forEach(function (p) {
          var r = p.im.getBoundingClientRect();
          p.visible = r.width > 0;
          p.rect = { l: r.left - s.left, t: r.top - s.top, w: r.width, h: r.height };
          p.cx = p.rect.l + p.fx * r.width;
          p.cy = p.rect.t + p.fy * r.height;
          if (!p.visible || !p.et) return;
          var lw = p.et.offsetWidth;
          var lh = p.et.offsetHeight;
          var lx;
          var ly;
          if (etroit) {
            p.et.classList.remove('a-gauche');
            lx = (W - lw) / 2;
            ly = basEntete + 14;
          } else {
            var gauche = p.cx > W * 0.58;
            p.et.classList.toggle('a-gauche', gauche);
            lx = gauche ? p.rect.l + p.rect.w * 0.12 - lw : p.rect.l + p.rect.w * 0.88;
            ly = p.cy - lh / 2 - 10;
            lx = Math.min(Math.max(lx, 16), W - lw - 16);
            ly = Math.min(Math.max(ly, basEntete + 14), H - lh - 24);
          }
          p.et.style.setProperty('--lx', Math.round(lx) + 'px');
          p.et.style.setProperty('--ly', Math.round(ly) + 'px');
        });
        if (spot.tr) spot.tr = rayon();
      }

      function cible() {
        for (var k = 0; k < pieces.length; k++) {
          var j = (rang + k) % pieces.length;
          if (pieces[j].visible) { rang = j; return pieces[j]; }
        }
        return pieces[0];
      }

      function suivre(cx, cy) {
        var s = root.getBoundingClientRect();
        spot.tx = cx - s.left;
        spot.ty = cy - s.top;
        mode = 'souris';
        dernier = performance.now();
      }

      function pieceSous(x, y) {
        for (var i = 0; i < pieces.length; i++) {
          var p = pieces[i];
          if (p.visible && p.et && p.et.classList.contains('est-vue') && x >= p.rect.l && x <= p.rect.l + p.rect.w && y >= p.rect.t && y <= p.rect.t + p.rect.h) return p;
        }
        return null;
      }

      function image(t) {
        if (!visible) { boucle = false; return; }
        if (mode === 'souris' && t - dernier > 3200) { mode = 'auto'; depuis = t; }
        if (mode === 'auto' && pret) {
          if (!reduit && t - depuis > ARRET) { rang = (rang + 1) % pieces.length; depuis = t; }
          var c = cible();
          spot.tx = c.cx;
          spot.ty = c.cy;
        }
        var k = mode === 'souris' ? 0.16 : 0.05;
        spot.x += (spot.tx - spot.x) * k;
        spot.y += (spot.ty - spot.y) * k;
        spot.r += (spot.tr - spot.r) * 0.06;
        var meilleur = -1;
        var dmin = 1e9;
        pieces.forEach(function (p, i) {
          if (!p.visible) return;
          var dx = p.cx - spot.x;
          var dy = p.cy - spot.y;
          var d = Math.sqrt(dx * dx + dy * dy);
          if (d < dmin) { dmin = d; meilleur = i; }
        });
        pieces.forEach(function (p, i) {
          if (p.et) p.et.classList.toggle('est-vue', pret && i === meilleur && dmin < spot.r * 0.5);
        });
        var st = root.style;
        st.setProperty('--sx', spot.x.toFixed(1) + 'px');
        st.setProperty('--sy', spot.y.toFixed(1) + 'px');
        st.setProperty('--r', Math.max(0.5, spot.r).toFixed(1) + 'px');
        var px = W / 2;
        var py = -0.14 * H;
        var ang = (Math.atan2(spot.x - px, -(spot.y - py)) * 180) / Math.PI;
        var dist = Math.sqrt((spot.x - px) * (spot.x - px) + (spot.y - py) * (spot.y - py));
        var demi = (Math.atan((spot.r * 0.42) / Math.max(dist, 1)) * 180) / Math.PI;
        st.setProperty('--a0', (ang - demi).toFixed(2) + 'deg');
        st.setProperty('--ouv', (2 * demi).toFixed(2) + 'deg');
        st.setProperty('--fy', ((spot.y / H) * 100).toFixed(1) + '%');
        requestAnimationFrame(image);
      }

      function lancer() {
        if (!boucle) { boucle = true; requestAnimationFrame(image); }
      }

      function allumer() {
        if (allume) return;
        allume = true;
        geo();
        var c = cible();
        spot.x = spot.tx = c.cx;
        spot.y = spot.ty = c.cy;
        if (reduit) {
          spot.r = spot.tr = rayon();
          pret = true;
          return;
        }
        spot.r = 0;
        spot.tr = 0;
        root.classList.add('est-allumage');
        setTimeout(function () { spot.tr = rayon(); }, 300);
        setTimeout(function () { pret = true; depuis = performance.now(); }, 1600);
      }

      root.addEventListener('pointermove', function (e) { if (pret) suivre(e.clientX, e.clientY); });
      root.addEventListener('pointerdown', function (e) { if (pret && e.pointerType !== 'mouse') suivre(e.clientX, e.clientY); });
      root.addEventListener('pointerleave', function (e) { if (e.pointerType === 'mouse') dernier = 0; });
      root.addEventListener('click', function (e) {
        if (e.target.closest('a')) return;
        var s = root.getBoundingClientRect();
        var p = pieceSous(e.clientX - s.left, e.clientY - s.top);
        if (p && p.et) window.location.href = p.et.getAttribute('href');
      });
      pieces.forEach(function (p, i) {
        if (!p.et) return;
        p.et.addEventListener('focus', function () {
          rang = i;
          mode = 'auto';
          depuis = performance.now();
        });
      });
      lumieres.forEach(function (im) {
        if (!im.complete) im.addEventListener('load', geo);
      });
      window.addEventListener('resize', function () { if (visible) geo(); });

      if ('IntersectionObserver' in window) {
        new IntersectionObserver(
          function (entrees) {
            visible = entrees[0].isIntersecting;
            if (visible) {
              geo();
              if (entrees[0].intersectionRatio >= 0.35) allumer();
              lancer();
            }
          },
          { threshold: [0, 0.35, 0.6] }
        ).observe(root);
      } else {
        visible = true;
        allumer();
        lancer();
      }
    }

    function tout() {
      document.querySelectorAll('[data-wl-vitrine]').forEach(init);
    }
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', tout);
    } else {
      tout();
    }
    document.addEventListener('shopify:section:load', function (e) {
      var r = e.target.querySelector('[data-wl-vitrine]');
      if (r) init(r);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
